import React from 'react';
import { Card } from '../common';

import './highlight.component.css';

const Highlight = (props) => {
  const getValueColor = (val) => {
    const lowerCaseVal = val.toLowerCase();
    let color;
    if (
      lowerCaseVal === 'good' ||
      lowerCaseVal === 'well diversified' ||
      lowerCaseVal === 'low' ||
      lowerCaseVal.includes('above')
    ) {
      color = '#0AC20A';
    } else if (lowerCaseVal === 'above average') {
      color = '#EAC20A';
    } else if (lowerCaseVal === 'average' || lowerCaseVal.includes('on par')) {
      color = '#0A7BC2';
    } else if (lowerCaseVal === 'below average') {
      color = '#EB7429';
    } else if (
      lowerCaseVal === 'poor' ||
      lowerCaseVal === 'high' ||
      lowerCaseVal === 'concentrated' ||
      lowerCaseVal.includes('below average')
    ) {
      color = '#EB0A0A';
    } else {
      color = '#0A7BC2';
    }

    return color;
  };
  return (
    <Card height="100%">
      <div className="highlight-title">{props.title}</div>
      <div
        style={{
          color: getValueColor(props.val),
        }}
        className="highlight-content"
      >
        {props.valText || props.val}
      </div>
      <div className="highlight-extra"></div>
    </Card>
  );
};

export default Highlight;
